const SUMMARY_DIMENSION_KEYS = {
  purpose: "by_purpose",
  caller: "by_caller",
  model: "by_model",
};

export function summaryDimensionToBreakdown(summary, dimension) {
  const summaryKey = SUMMARY_DIMENSION_KEYS[dimension];
  if (!summaryKey || !summary?.[summaryKey]) {
    return [];
  }

  return Object.entries(summary[summaryKey])
    .map(([name, values]) => ({
      name,
      cost_usd: values?.cost_usd || 0,
      call_count: values?.call_count || 0,
      input_tokens: values?.input_tokens || 0,
      output_tokens: values?.output_tokens || 0,
    }))
    .filter((row) => row.name !== "unknown" || row.cost_usd)
    .sort((a, b) => b.cost_usd - a.cost_usd);
}
